export const PRODUCT_TYPES = {
    NAMENLOS_STYLE: 'NAMENLOS_STYLE',
    AIR_ELEMENTAL_STYLE: 'AIR_ELEMENTAL_STYLE',
    EARTH_ELEMENTAL_STYLE: 'EARTH_ELEMENTAL_STYLE',
    WATER_ELEMENTAL_STYLE: 'WATER_ELEMENTAL_STYLE',
    FIRE_ELEMENTAL_STYLE: 'FIRE_ELEMENTAL_STYLE',
    PFP_BATTLES: 'PFP_BATTLES',
    TANK: 'TANK',
    BONDS: 'BONDS',
    GOLD: 'GOLD',
    SILVER: 'SILVER',
    PREMIUM_PLUS: 'PREMIUM_PLUS',
    DIGITAL_CAMOUFLAGE_WINTER: 'DIGITAL_CAMOUFLAGE_WINTER',
    DIGITAL_CAMOUFLAGE_SUMMER: 'DIGITAL_CAMOUFLAGE_SUMMER',
    DIGITAL_CAMOUFLAGE_DESERT: 'DIGITAL_CAMOUFLAGE_DESERT',
    DIGITAL_STYLE: 'DIGITAL_STYLE',
    VETERAN_STYLE: 'VETERAN_STYLE',
    VANQUISHER_STYLE: 'VANQUISHER_STYLE',
    CONQUEROR_STYLE: 'CONQUEROR_STYLE',
    NIGHTFALL_STYLE: 'NIGHTFALL_STYLE',
    BROKEN_STONE_STYLE: 'BROKEN_STONE_STYLE',
    EMBLEM: 'EMBLEM',
    PERSONAL_RESERVE_SMALL: 'PERSONAL_RESERVE_SMALL',
    PERSONAL_RESERVE_BIG: 'PERSONAL_RESERVE_BIG',
    CREW_EXPERIENCE: 'CREW_EXPERIENCE',
    FREE_EXPERIENCE: 'FREE_EXPERIENCE',
    EXPERIENCE: 'EXPERIENCE',
    FREE_XP_AND_CREW_XP: 'FREE_XP_AND_CREW_XP',
    XP_RESERVE: 'XP_RESERVE',
    DIRECTIVES_PACK: 'DIRECTIVES_PACK',
    DIRECTIVES_PACK_30: 'DIRECTIVES_PACK_30',
    CREW_WOMAN: 'CREW_WOMAN',
    LIGHTNING_STYLE: 'LIGHTNING_STYLE',
    CREW_BOOK_NATIONAL: 'CREW_BOOK_NATIONAL',
    GRAPHITE_STYLE: 'GRAPHITE_STYLE',
    FIRE_STYLE: 'FIRE_STYLE',
    DIGITAL_ADAPTED_STYLE: 'DIGITAL_ADAPTED_STYLE',
    CLAN_URBAN_STYLE: 'CLAN_URBAN_STYLE',
    GUARDIAN_OF_CROWN_STYLE: 'GUARDIAN_OF_CROWN_STYLE',
    PROPHESY_STYLE: 'PROPHESY_STYLE',
    JUDGEMENT_STYLE: 'JUDGEMENT_STYLE',
    REAPER_STYLE : 'REAPER_STYLE',
    PROSERPINA_STYLE: 'PROSERPINA_STYLE',
    HELLRAISER_STYLE: 'HELLRAISER_STYLE',
    WARRIOR_OF_THE_EAST_STYLE: 'WARRIOR_OF_THE_EAST_STYLE',
    WARRIOR_OF_THE_NORTH_STYLE: 'WARRIOR_OF_THE_NORTH_STYLE',
    WARRIOR_OF_THE_SOUTH_STYLE: 'WARRIOR_OF_THE_SOUTH_STYLE',
    WARRIOR_OF_THE_WEST_STYLE: 'WARRIOR_OF_THE_WEST_STYLE',
    KRAIT_STYLE: 'KRAIT_STYLE',
    BASALT_STYLE: 'BASALT_STYLE',
}

export const REWARDS_TYPES = {
    TANK: 'TANK',
}

export const GROUP_TYPES = {
    root: 'root',
    nation: 'nation',
}

export const PARTITION_TYPES = {
    rewards: 'rewards',
    products: 'products',
}



// WEBPACK FOOTER //
// ./containers/WGCWXShop/constants.js